import React from 'react';
import { motion } from 'framer-motion';
import { FaCheck, FaGlobeAmericas, FaUsers, FaTruck, FaHandshake } from 'react-icons/fa';

const WhyChooseUs = () => {
  const advantages = [
    {
      icon: <FaUsers className="text-white text-3xl mb-4" />,
      title: "Équipe Expérimentée",
      description: "Notre équipe multilingue possède une expertise approfondie en importation et distribution au Canada."
    },
    {
      icon: <FaGlobeAmericas className="text-white text-3xl mb-4" />,
      title: "Connaissance du Marché",
      description: "Une compréhension intime du marché canadien et de ses spécificités régionales."
    },
    {
      icon: <FaTruck className="text-white text-3xl mb-4" />,
      title: "Infrastructure Fiable",
      description: "Réseau logistique étendu et réactif assurant des livraisons ponctuelles et sécurisées."
    },
    {
      icon: <FaHandshake className="text-white text-3xl mb-4" />,
      title: "Partenariats Solides",
      description: "Relations de confiance établies avec les principales chaînes de distribution canadiennes."
    }
  ];

  return (
    <section className="section bg-primary text-white">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Pourquoi Nous Choisir</h2>
          <p className="text-xl opacity-90 max-w-3xl mx-auto">
            Nos avantages concurrentiels pour vous garantir un développement optimal
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {advantages.map((advantage, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-white/10 backdrop-blur-sm p-6 rounded-lg flex flex-col items-center text-center"
            >
              <div>{advantage.icon}</div>
              <h3 className="text-xl font-bold mb-3">{advantage.title}</h3>
              <p className="opacity-90">{advantage.description}</p>
            </motion.div>
          ))}
        </div>

        <div className="mt-16 bg-white/10 backdrop-blur-sm p-8 rounded-lg">
          <h3 className="text-2xl font-bold mb-6 text-center">Notre Engagement</h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-4">
              <div className="flex items-start">
                <div className="bg-white/20 p-2 rounded-full mr-4 mt-1">
                  <FaCheck className="text-green-400" />
                </div>
                <div>
                  <h4 className="font-bold text-lg mb-1">Qualité et conformité</h4>
                  <p className="opacity-80">Nous garantissons que vos produits respectent toutes les normes canadiennes.</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="bg-white/20 p-2 rounded-full mr-4 mt-1">
                  <FaCheck className="text-green-400" />
                </div>
                <div>
                  <h4 className="font-bold text-lg mb-1">Transparence</h4>
                  <p className="opacity-80">Communication claire et régulière sur les performances de vos produits.</p>
                </div>
              </div>
            </div>
            
            <div className="space-y-4">
              <div className="flex items-start">
                <div className="bg-white/20 p-2 rounded-full mr-4 mt-1">
                  <FaCheck className="text-green-400" />
                </div>
                <div>
                  <h4 className="font-bold text-lg mb-1">Croissance durable</h4>
                  <p className="opacity-80">Des stratégies à long terme pour une expansion pérenne sur le marché canadien.</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="bg-white/20 p-2 rounded-full mr-4 mt-1">
                  <FaCheck className="text-green-400" />
                </div>
                <div>
                  <h4 className="font-bold text-lg mb-1">Réactivité</h4>
                  <p className="opacity-80">Une équipe disponible et réactive pour répondre à vos besoins spécifiques.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs; 